import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      webhooks: {
        header: 'HEADER',
        add_webhook: 'ADD_WEBHOOK',
        modal_window: {
          create: {
            title: 'CREATE_TITLE',
            webhook_type: 'CREATE_TYPE',
            save: 'CREATE_YES',
            cancel: 'CREATE_CANCEL',
          },
        },
        webhook_settings: {
          header: 'SETTINGS_HEADER',
          webhook_type: 'SETTINGS_TYPE',
          active: 'SETTINGS_ACTIVE',
          success_confirmation: 'SETTINGS_SUCCESS_CONFIRMATION',
          checkboxes_label: 'SETTINGS_CHECKBOXES',
          back: 'SETTINGS_BACK',
          condition: {
            label: 'SETTINGS_CONDITION_LABEL',
            set_condition: 'SETTINGS_CONDITION_SET',
            add_condition_btn: 'SETTINGS_CONDITION_ADD',
            modal: {
              title: 'SETTINGS_CONDITION_MODAL_TITLE',
              save: 'SETTINGS_CONDITION_MODAL_SAVE',
              cancel: 'SETTINGS_CONDITION_MODAL_CANCEL',
              form: {
                obtained_result: 'SETTINGS_FORM_CONDITION_RESULT',
                condition_for_comparison: 'SETTINGS_FORM_CONDITION_CONDITION',
                desired_value: 'SETTINGS_FORM_CONDITION_VALUE',
              },
            },
            remove_condition_modal: {
              title: 'SETTINGS_REMOVE_TITLE',
              question: 'SETTINGS_REMOVE_QUESTION',
              answer_yes: 'SETTINGS_REMOVE_YES',
              answer_no: 'SETTINGS_REMOVE_NO',
            },
          },
          url_constructor: {
            label: 'URL_LABEL',
            url: 'URL_URL',
            request_method: 'URL_REQUEST_METHOD',
            result_url: 'URL_RESULT_URL',
            source_url: 'URL_SOURCE_URL',
            source_url_generate: 'URL_SOURCE_URL_GENERATE',
            errors: {
              source_url_invalid: 'URL_ERROR_SOURCE_URL_INVALID',
            },
            table: {
              header: {
                key: 'URL_TABLE_HEADER_KEY',
                value: 'URL_TABLE_HEADER_VALUE',
                description: 'URL_TABLE_HEADER_DESCRIPTION',
              },
              body: {
                key: 'URL_TABLE_BODY_KEY',
                value: 'URL_TABLE_BODY_VALUE',
                description: 'URL_TABLE_BODY_DESCRIPTION',
              },
            },
          },
        },
        tabs: {
          registration: {
            tab_name: 'TAB_REGISTRATION',
          },
          deposit: {
            tab_name: 'TAB_DEPOSIT',
          },
          activity: {
            tab_name: 'TAB_ACTIVITY',
          },
        },
      },
    },
    admin: {
      partners: {
        list_partners: {
          webhooks: {
            header: 'ADMIN_HEADER',
            back: 'ADMIN_BACK',
            webhook_settings: {
              header: 'ADMIN_SETTINGS_HEADER',
            },
          },
        },
      },
    },
  }));
}
